/**
 * HeirWise brand glossary — single source of truth.
 *
 * Every component, page, email template, or piece of metadata that references
 * canonical brand terms (product name, instructor collective, instructor names,
 * pillar titles, etc.) MUST import from this file rather than hard-coding the
 * string. This guarantees a single rename here propagates everywhere.
 */

export const BRAND = {
  /** Product / platform name. */
  productName: "HeirWise",
  /** Public-facing tagline used in marketing surfaces. */
  tagline: "Financial mastery for the next generation",
  /** Primary domain, used in copy and email templates. */
  domain: "heirwise.app",

  /** The in-universe collective of instructor guides. */
  collective: {
    /** Canonical name — never inline this string elsewhere. */
    name: "Luminar Collective",
    /** With a leading article, for sentence-natural usage. */
    nameWithArticle: "the Luminar Collective",
    /** Title-case heading variant ("The Luminar Collective"). */
    nameTitleCase: "The Luminar Collective",
  },

  /** The three pillars of financial mastery. */
  pillars: {
    finance: "Finance",
    economics: "Economics",
    entrepreneurship: "Entrepreneurship",
  },

  /** In-universe instructor guides (Luminar Collective members). */
  instructors: {
    finance: {
      name: "Aelyra Solari",
      title: "Finance Instructor",
      pillar: "finance" as const,
    },
    economics: {
      name: "Caelion Veyr",
      title: "Economics Instructor",
      pillar: "economics" as const,
    },
    entrepreneurship: {
      name: "Headmaster Vaelor Eryndor",
      title: "Entrepreneurship Instructor",
      pillar: "entrepreneurship" as const,
    },
  },
} as const;

/** Convenience: ordered list of instructors for iteration in UI. */
export const INSTRUCTOR_LIST = [
  BRAND.instructors.finance,
  BRAND.instructors.economics,
  BRAND.instructors.entrepreneurship,
] as const;

export type BrandInstructor = (typeof INSTRUCTOR_LIST)[number];